import Vue from 'vue';
import DownloadContainer from "./DownloadContainer.vue"

function initDownloadoverview() {
    if (document.querySelector('.content__downloads')) {
        new Vue({
            name: 'ContentDownloads',
            el: '.content__downloads',
            components: {
                DownloadContainer,
            },
            data: {
                selectedCategory: 0,
                parents: [],
            },
            methods: {
                setCategoryId(id) {
                    if (id === this.selectedCategory) {
                        id = 0;
                    }
                    this.selectedCategory = id;
                },
                getCategoryId() {
                    return this.selectedCategory;
                },
                setParents(data) {
                    this.parents = data;
                },
                getParents() {
                    return this.parents;
                },
            },
            mounted() { }
        });
    }
}

document.addEventListener("DOMContentLoaded", initDownloadoverview);
window.addEventListener("Pageeditor:insert", initDownloadoverview);
window.addEventListener("Pageeditor:change", initDownloadoverview);
